<template>
  <div class="row">
    <div class="col-4 mb-2">
      <LabelAndValue
        :i18n-key="'summaryPanel.organization.corporateName'"
        :value="organization.name"
        :oneLine="true"
        :value-style="valueStyle"
        :label-style="labelStyleItem"
        :div-value-style="divValueStyle"
      />
    </div>
    <div class="col-4 mb-2">
      <LabelAndValue
        :i18n-key="'summaryPanel.organization.commercialName'"
        :value="organization.commercialName"
        :oneLine="true"
        :value-style="valueStyle"
        :label-style="labelStyleItem"
        :div-value-style="divValueStyle"
      />
    </div>
    <div class="col-4 mb-2">
      <LabelAndValue
        :i18n-key="'summaryPanel.organization.legalCategory'"
        :value="legalCategory"
        :oneLine="true"
        :value-style="valueStyle"
        :label-style="labelStyleItem"
        :div-value-style="divValueStyle"
      />
    </div>
    <div class="col-4 mb-2">
      <LabelAndValue
        :i18n-key="'party.APE'"
        :value="
          $t(`picklists.activity.${organization.activitySector.type.value}`)
        "
        :oneLine="true"
        :value-style="valueStyle"
        :label-style="labelStyleItem"
        :div-value-style="divValueStyle"
      />
    </div>
    <div class="col-4 mb-2">
      <LabelAndValue
        :i18n-key="'summaryPanel.organization.siren'"
        :value="organization.siren"
        :oneLine="true"
        :value-style="valueStyle"
        :label-style="labelStyleItem"
        :div-value-style="divValueStyle"
      />
    </div>
    <div class="col-4 mb-2">
      <LabelAndValue
        :i18n-key="'summaryPanel.organization.phoneNumber'"
        :value="contacts?.get(contactType.PHONE_CONTACT)"
        :oneLine="true"
        :value-style="valueStyle"
        :label-style="labelStyleItem"
        :div-value-style="divValueStyle"
      />
    </div>
    <div class="col-4 mb-2">
      <LabelAndValue
        :i18n-key="'summaryPanel.organization.email'"
        :value="contacts?.get(contactType.EMAIL_CONTACT)"
        :oneLine="true"
        :value-style="valueStyle"
        :label-style="labelStyleItem"
        :div-value-style="divValueStyle"
      />
    </div>
  </div>
  <q-expansion-item
    default-opened
    expand-icon-toggle
    header-class="align-items-center bg-secondary justify-content-between mb-3 mt-3"
    v-if="organization.manager"
  >
    <template v-slot:header>
      {{ capitalize($t("demand.party.roles.DIRG").toLowerCase()) }}
    </template>
    <div class="row">
      <div class="col-4 mb-2">
        <LabelAndValue
          :i18n-key="'summaryPanel.organization.title'"
          :value="$t(`demand.party.title.${organization.manager.title.type.value}`)"
          :oneLine="true"
          :value-style="valueStyle"
          :label-style="labelStyleItem"
          :div-value-style="divValueStyle"
        />
      </div>
      <div class="col-4 mb-2">
        <LabelAndValue
          :i18n-key="'summaryPanel.organization.fullName'"
          :value="(organization.manager.firstName && organization.manager.familyName) ? (organization.manager.firstName + ' ' + organization.manager.familyName) : ''"
          :oneLine="true"
          :value-style="valueStyle"
          :label-style="labelStyleItem"
          :div-value-style="divValueStyle"
        />
      </div>
      <div class="col-4 mb-2">
        <LabelAndValue
          :i18n-key="'summaryPanel.organization.birthday'"
          :value="organization.manager.birthDate"
          :oneLine="true"
          :value-style="valueStyle"
          :label-style="labelStyleItem"
          :div-value-style="divValueStyle"
        />
      </div>
      <div class="col-4 mb-2">
        <LabelAndValue
          :i18n-key="'summaryPanel.organization.phoneNumber'"
          :value="managerPhoneNumber"
          :oneLine="true"
          :value-style="valueStyle"
          :label-style="labelStyleItem"
          :div-value-style="divValueStyle"
        />
      </div>
    </div>
  </q-expansion-item>
  <div v-if="!order ||(order!=='order')">
    <q-expansion-item v-if="rows && rows.length != 0" default-opened expand-icon-toggle
     header-class="align-items-center justify-content-between mb-3 mt-3" class="bg-secondary">
    <template v-slot:header>
      <div>
        {{
          capitalize(
            $t("middleOffice.party.organization.section.classification").toLowerCase()
          )
        }}
      </div>
    </template>
    <div class="mb-3 pl-3 pr-3">
      <div v-for="item in rows" :key="item.id">
        <div class="same-line">
          <span>
            {{ $t('main.type') }}:
          </span>
          <span class="text-dark font-weight-bold"> {{ $t("picklists.partyClassificationType." + item.class_type_code)
          }}</span>
        </div>

        <table class="shadow-0 table table-sm  mb-0">
          <thead>
            <tr>
              <th class="text-dark font-weight-bold">
                {{ $t("task.labels.value") }}
              </th>
              <th class="text-dark font-weight-bold">
                {{ $t("communication.comMessage.User") }}
              </th>
              <th class="text-dark font-weight-bold">
                {{ $t("scales.services.filter.validity") }}
              </th>
              <th class="text-dark font-weight-bold">
                {{ $t("main.labels.classificationDate") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t(`demand.party.partyClass.${item.id}`) }}</td>
              <td>{{ item.first_name ? item.first_name + ' ' + item.last_name : item._who_created }}</td>
              <td>{{ `${item.validity_from ? formatDate(item.validity_from) : ''} - ${item.validity_until ? formatDate(item.validity_until) : ''}` }}</td>
              <td>{{ formatDate(item.classification_date) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </q-expansion-item>
</div>
<q-expansion-item v-if="financialExposureTable && financialExposureTable.length != 0" default-opened expand-icon-toggle
    header-class="align-items-center justify-content-between mb-3 mt-3" class="bg-secondary">
    <template v-slot:header>
      <div>
        {{
          capitalize(
            $t("middleOffice.party.organization.section.exposure").toLowerCase()
          )
        }}
      </div>
    </template>
    <div v-for="(item, index) in financialExposureTable" :key="index" class="mb-3 pl-3 pr-3" >
      <div class="same-line">
        <span>
          {{ $t('middleOffice.party.organization.exposure.Outstanding_entity') }}:
        </span>
        <span class="text-dark font-weight-bold">{{ item.financialInstitution || '' }}</span>
      </div>
      <q-table :rows="item.outstandingTypes" :columns="columns" row-key="financialInstitution" hide-pagination
        class="shadow-0 table table-sm  mb-0">
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props" class="text-dark font-weight-bold">
              {{ $t(col.label) }}
            </q-th>
            <q-th auto-width />
          </q-tr>
        </template>
      </q-table>
    </div>

  </q-expansion-item>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import LabelAndValue from "@/components/general/LabelAndValue.vue";
import { globalConfig } from "@/utils";
import {
  contacts,
  getPartyClass,
  populateContactsMap,
} from "@/components/summary-panel/summary";
import { ContactType, PartyContactCorrespondent } from "@/types";
import store from "@/store";
import i18n from "@/i18n";
import { formatDate } from "@/utils/configuration/formatters-config";

@Options({
  methods: { getPartyClass },
  components: { LabelAndValue },
  props: ["organization", "manager","order"],
  created() {
       populateContactsMap(
       this.organization?.contacts
      );
    store.dispatch("middleOfficeModule/searchClassification", {
      filter: {
        id: this.organization.resourceUid,
      },
      callback: this.updateResultRows,
    });
  },
})
export default class SummaryOrganization extends Vue {
  organization: any;
  manager: any;
  order?:string;
  rows: any[] = [];
  formatDate = formatDate;

  capitalize = globalConfig.capitalize;

  get contactType() {
    return ContactType;
  }

  get contacts() {
    return contacts;
  }

  get financialExposureTable() {
    const rawData = this.organization?.financialExposures as unknown as {
      financialInstitution: { value: string };
      outstandingType: { value: string };
      netOutstanding: number;
      grossOutstanding: number;
      residualValue: number;
      contractValidity: { until: string };
    }[];

    const currentDate = new Date(); // Get the current system date

    const groupedData: {
      [key: string]: {
        financialInstitution: string;
        outstandingTypes: {
          [key: string]: {
            netOutstanding: number;
            grossOutstanding: number;
            residualValue: number;
          }
        };
      }
    } = rawData.reduce((acc: any, el: any) => {
      const key = el.financialInstitution.value;
      if (el.contractValidity.until) {
        const contractUntilDateParts = el.contractValidity.until.split('/'); // Split the date string
        const contractUntilDate = new Date(
          Number(contractUntilDateParts[2]), // Year
          Number(contractUntilDateParts[1]) - 1, // Month (subtract 1 because months are zero-based)
          Number(contractUntilDateParts[0]) // Day
        );

        // Check if the contract is still valid (until date is greater than current system date)
        if (contractUntilDate > currentDate) {
          if (!acc[key]) {
            acc[key] = {
              financialInstitution: el.financialInstitution.value,
              outstandingTypes: {}
            };
          }
          const outstandingTypeKey = el.outstandingType.value;
          if (!acc[key].outstandingTypes[outstandingTypeKey]) {
            acc[key].outstandingTypes[outstandingTypeKey] = {
              netOutstanding: 0,
              grossOutstanding: 0,
              residualValue: 0
            };
          }
          // Accumulate values for specific outstanding type
          acc[key].outstandingTypes[outstandingTypeKey].netOutstanding += el.netOutstanding || 0;
          acc[key].outstandingTypes[outstandingTypeKey].grossOutstanding += el.grossOutstanding || 0;
          acc[key].outstandingTypes[outstandingTypeKey].residualValue += el.residualValue || 0;
        }
      }
      return acc;
    }, {});

    // Transforming data for display
    const transformedData = Object.values(groupedData).map(item => ({
      financialInstitution: i18n.global.t(
        "middleOffice.party.organization.financialInstitution." + item.financialInstitution),
      outstandingTypes: Object.entries(item.outstandingTypes).map(([key, value]) => ({
        outstandingType: i18n.global.t(
          "middleOffice.party.organization.typeOutstanding." + key),
        netOutstanding: value.netOutstanding.toFixed(2),
        grossOutstanding: value.grossOutstanding.toFixed(2),
        residualValue: value.residualValue.toFixed()
      }))
    }));

    return transformedData;
  }

  updateResultRows(rows: any) {
    this.rows = this.filterLatestValidity(rows);
  }
  filterLatestValidity(rows: any[]) {
    const latestValidityMap = new Map();
    rows.forEach(row => {
      const classTypeCode = row.class_type_code;
      if (!latestValidityMap.has(classTypeCode) ||
        row.validity_from > latestValidityMap.get(classTypeCode).validity_from ||
        (row.validity_from === latestValidityMap.get(classTypeCode).validity_from &&
         row.validity_until > latestValidityMap.get(classTypeCode).validity_until)) {
      latestValidityMap.set(classTypeCode, row);
    }
    });
    const filteredRows = Array.from(latestValidityMap.values());
    return filteredRows;
  }
 get legalCategory() {
  return store.getters["picklistModule/legalCategoryItems"].map((item: any) => {
      return {
        ...item,
        label: item.value?.toString() !== "" ?`${item.value} - ${i18n.global.t(`picklists.legal-category.${item.value}`)}` : ''
      };
    }).filter((o: any) => o.value === this.organization.legalCategory.type.value)
      .map((o: any) => o.label).join('. ');
  }
  
 get managerPhoneNumber(){
  return this.organization.manager.contacts.filter((con:any) => con.contactMechanism.type?.id?.includes('PHONE_CONTACT'))[0]?.contactMechanism?.phoneNumber
 }
  valueStyle = {
    "font-weight": "bold",
    "margin-left": "20px",
    color: "black",
  };

  divValueStyle = {
    display: "flex",
    "justify-content": "end",
    "padding-right": "10px",
  };
  labelStyleItem = {
    "font-size": "1rem",
    color: "gray",
    "font-weight": "bold",
  };
}
</script>

<style lang="scss" scoped>
</style>
